import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './skipModule.module.scss';
import { SkipModuleProps } from './skipModule.interface';
import { Notes } from '../notes/notes.dumb';
import { di } from '../../../../../../state/inversify.config';
import { AssessmentCreationViewService } from '../../../assessmentCreationView/assessmentCreation.view.service';
import { Checkbox } from '../../../../../../components/checkBox/checkBox';

export function SkipModule({
  moduleKeyValue,
  skipModuleFlag,
  skipModuleComments,
  onChange,
}: SkipModuleProps) {
  const { t } = useTranslation();
  const assessmentCreationViewService = di.get<AssessmentCreationViewService>(
    AssessmentCreationViewService,
  );

  const saveSkipModuleFlag = (key: string, value: boolean) => {
    assessmentCreationViewService.dispatchSetAssessmentModuleDetails(
      moduleKeyValue,
      key,
      value,
    );

    if (onChange) {
      onChange(value);
    }

    if (!value) {
      saveSkipModuleComments('skipModuleComments', '');
    }
  };

  const saveSkipModuleComments = (key: string, value: string) => {
    if (!skipModuleFlag && value.length) {
      saveSkipModuleFlag('skipModuleFlag', true);
    }

    assessmentCreationViewService.dispatchSetAssessmentModuleDetails(
      moduleKeyValue,
      key,
      value,
    );
  };

  return (
    <div className={styles.outerContainer}>
      <Checkbox
        label={t('assessment.ID_GENERIC_SKIP_MODULE')}
        onChange={(event) =>
          saveSkipModuleFlag('skipModuleFlag', event.target.checked)
        }
        checked={skipModuleFlag}
        name="skipModule"
      />
      {skipModuleFlag && (
        <Notes
          label={t('assessment.ID_GENERIC_SKIP_MODULE_COMMENTS')}
          keyValue="skipModuleComments"
          onSave={saveSkipModuleComments}
          data={skipModuleComments}
          disabled={!skipModuleFlag}
          fullWidth
        />
      )}
    </div>
  );
}
